<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-checkbox v-model="checkboxList[item.name + '_boolean']" :key="index" :label="1"
                         v-for="(item,index) in field['checkbox-list']" @change="change(item.name)">{{item.text}}
            </el-checkbox>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
    .radio-item {
        padding-right: 20px;
        .radio {
            margin-bottom: 10px;
        }
    }
</style>

<script>

  export default {
    name: 'tms-type-checkbox-list',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        radio: 1,
        checkboxList: {}
      }
    },

    components: {},

    created() {

    },

    mounted() {
      // 重新设置checkbox数据
      if (this.field['checkbox-list'] instanceof Array) {
        this.field['checkbox-list'].map((val) => {
          this.$set(this.checkboxList, val.name + '_boolean', !!this.config[val.name]);
        })
      }
    },

    methods: {
      change(name) {
        if (this.checkboxList[name + '_boolean']) {
          this.config[name] = 1;
        } else {
          this.config[name] = 0;
        }
      }
    }
  }

</script>
